//export const API = "http://localhost:1060/api/v1";
//export const DOMAIN = https://idadev-api.ignithocloud.com
export const API = "https://idadev-api.ignithocloud.com/api/v1";
export const commonUrl = 'https://idadev.ignithocloud.com';